import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import styles from './styles.module.scss'

type IModalActionsProps = {
  onSave: () => void
  onCancel: () => void
  onDelete?: () => void
  isSaveDisabled?: () => boolean
}

export const ModalActions = observer(
  ({ onSave, onCancel, onDelete, isSaveDisabled }: IModalActionsProps) => (
    <div className={styles.wrap} onMouseDown={(e) => e.stopPropagation()}>
      {onDelete && (
        <Button
          typeBtn='contained'
          contained='secondary'
          intent='destructive'
          text='Delete action'
          className={styles.deleteAction}
          onClick={onDelete}
        />
      )}
      <Button typeBtn='contained' contained='secondary' text='Cancel' onClick={onCancel} />
      <Button typeBtn='contained' text='Save' disabled={isSaveDisabled?.()} onClick={onSave} />
    </div>
  )
)
